import React, { Dispatch, useEffect, useState } from 'react';
import { Container, ContFilter } from './styles';
import { FilterOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { loadRequest } from '../../../../store/ducks/entregaNoCd/actions';
import type { IEntregaNoCd } from '../../../../store/ducks/entregaNoCd/types';

import Filter from './components/Filter';
import TitlePage from '../../../../components/TitlePage';
import { ExportBtn } from '../../../../components/_REFACTORED/ExportBtn';
import { TableSec } from '../../../../components/_REFACTORED/SecondaryTable';
import TableSort from '../../../../components/TableSort';
import CardMobile from './components/CardMobile';
import GetStatus from '../../../../components/GetStatus';
import TextTable from '../../../../components/TextTable';
import Refresh from '../../../../components/Refresh';
import TitleTable from '../../../../components/TitleTable';
import ModalCriarOrdemDeCarga from '../../components/ModalCriarOrdemDeCarga';

import mask from '../../../../utils/mask';
import { Sorter, sorterParamsHandle } from '../../../../utils/sorte';
import { useWindowSize } from '../../../../hook/useWindowSize';
import { exportDataEntregaNoCd } from './hooks';
import { EntregaNoCdServices } from './services/entregaNoCdServices';
import { TIPO_WMS } from 'utils/enums/tipoWms';

export interface IOrdemCargaEntragaValues {
  assoalho: string;
  clienteRetira: boolean;
  codParcMotorista: number;
  codTransportadora: number;
  codVeiculo: number;
  selectedTomadorOrdemCarga: number;
  tipVei: number;
  ArraynuNotas: number[];
}

const EntregaNoCd: React.FC = () => {
  const { width }: any = useWindowSize();
  const dispatch = useDispatch<Dispatch<Action>>();
  const entregas = useSelector((state: ApplicationState) => state.EntregaNoCd.data);
  const loading = useSelector((state: ApplicationState) => state.EntregaNoCd.loading);
  const pagination = useSelector((state: ApplicationState) => state.EntregaNoCd.pagination);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const filter = useSelector((state: ApplicationState) => state.EntregaNoCd.filter);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const [filterActive, setFilterActive] = useState<string[]>([]);

  const getData = async () => {
    const { data } = await EntregaNoCdServices.getAllData(
      cddAtivo?.codCdd,
      filter,
      inscricaoAtiva,
      pagination.total
    );
    return exportDataEntregaNoCd(data.entregas);
  };

  const columns: ColumnsType<IEntregaNoCd> = [
    {
      title: <TitleTable>Ordem de carga</TitleTable>,
      dataIndex: 'ordemCarga',
      key: 'ordemCarga',
      align: 'left',
      width: 120,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: <TitleTable>Status</TitleTable>,
      dataIndex: 'status',
      key: 'status',
      width: 280,
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text) => {
        return <GetStatus acronym={text} />;
      },
    },
    {
      title: <TitleTable>Transportadora</TitleTable>,
      dataIndex: 'nomeTransportadora',
      key: 'nomeTransportadora',
      align: 'center',
      width: 250,
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text, record) => {
        return record.clienteRetira ? (
          <TextTable>Cliente retira</TextTable>
        ) : text ? (
          <TextTable>{mask('transportadoraUf', text)}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Valor</TitleTable>,
      dataIndex: 'valor',
      key: 'valor',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 9,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('currency', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Peso</TitleTable>,
      dataIndex: 'peso',
      key: 'peso',
      align: 'center',
      width: 150,

      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 8,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('peso', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: <TitleTable>Placa</TitleTable>,
      dataIndex: 'placa',
      key: 'placa',
      align: 'center',
      width: 140,
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text) => {
        return text ? (
          <TextTable>{text?.toUpperCase()}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Tipo veículo</TitleTable>,
      dataIndex: 'tipoVeiculo',
      key: 'tipoVeiculo',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Nome do motorista</TitleTable>,
      dataIndex: 'nomeMotorista',
      key: 'nomeMotorista',
      align: 'center',
      width: 220,
      sorter: {
        compare: Sorter.STRING,
        multiple: 6,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>CPF</TitleTable>,
      dataIndex: 'cpfMotorista',
      key: 'cpfMotorista',
      align: 'center',
      width: 200,
      sorter: {
        compare: Sorter.STRING,
        multiple: 7,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('cpfCnpj', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: <TitleTable>Assoalho</TitleTable>,
      dataIndex: 'assoalho',
      key: 'assoalho',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.STRING,
        multiple: 11,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text === 'F' ? 'Ferro' : 'Madeira')}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: <TitleTable>Nome destinatário</TitleTable>,
      dataIndex: 'nomeDestinatario',
      key: 'nomeDestinatario',
      align: 'center',
      width: 320,
      sorter: {
        compare: Sorter.STRING,
        multiple: 10,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
  ];

  useEffect(() => {
    setFilterActive(Object.keys(filter ?? {}));
  }, [filter]);

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, pagination))
        }
      />
      <Filter />

      <Container>
        <TitlePage>
          <div>Entrega no CD</div>

          {filterActive.length > 0 && (
            <ContFilter>
              {filterActive.map((item) => (
                <p key={item}>
                  {item === 'placa' && (
                    <>
                      <FilterOutlined /> Placa
                    </>
                  )}
                  {item === 'status' && (
                    <>
                      <FilterOutlined />
                      Status
                    </>
                  )}
                  {item === 'codTipoVeiculo' && (
                    <>
                      <FilterOutlined />
                      Tipo de veículo
                    </>
                  )}
                  {item === 'codTransportadora' && (
                    <>
                      <FilterOutlined />
                      Transportadora
                    </>
                  )}
                  {item === 'ordemCarga' && (
                    <>
                      <FilterOutlined />
                      Ordem de carga
                    </>
                  )}
                </p>
              ))}
            </ContFilter>
          )}

          <div className="box">
            <ModalCriarOrdemDeCarga
              tipoWms={TIPO_WMS.entrega}
              atualizaTabelaEntrega={() =>
                dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number))
              }
              setaArraySelectedItens={()=>{}}

            />

            <ExportBtn
              onGetAllData={getData}
              screenData={exportDataEntregaNoCd(entregas)}
              filename={'entrega-no-cd'}
            />
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            rowKey={(index: number) => index}
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 1080 }}
            size={'large'}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  inscricaoAtiva,
                  cddAtivo?.codCdd as number,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
            }}
            pagination={pagination}
            className="table"
            dataSource={entregas}
            loading={loading}
            expandable={{
              expandedRowRender: (record: IEntregaNoCd) => (
                <TableSec ordemCarga={record.ordemCarga} codEmp={record.codEmp} />
              ),
            }}
          />
        )}
        {width <= 768 && (
          <CardMobile
            props={entregas}
            pagination={pagination}
            loading={loading}
            inscricaoAtiva={inscricaoAtiva}
            cddAtivo={cddAtivo}
            filter={filter}
          />
        )}
      </Container>
    </>
  );
};

export default EntregaNoCd;
